import { render } from "./ThirdSlide.vue?vue&type=template&id=6dfd3a0b&scoped=true"
import script from "./ThirdSlide.vue?vue&type=script&lang=js"
export * from "./ThirdSlide.vue?vue&type=script&lang=js"

import "./ThirdSlide.vue?vue&type=style&index=0&id=6dfd3a0b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dfd3a0b"]])

export default __exports__